exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sferumGroupHeader[data-v-44bc7016]{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:10px}.sferumGroupHeaderName[data-v-44bc7016]{font-weight:700}.sferumGroup[data-v-44bc7016]{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44bc7016","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/components/infoSferum/SferumWebinarGroup.vue
// module id = 8c5a910efe6bbcffa6a8
// module chunks = 14